// extracted by mini-css-extract-plugin
export default {"footer":"footer--SmiwR","links":"links--SmiwR","linkSeparator":"linkSeparator--SmiwR","link":"link--SmiwR","info":"info--SmiwR","disclaimer":"disclaimer--SmiwR"};